module.exports = __webpack_public_path__ + "media/in_destinum/img/mexico-city-tour-d1532cefa9c65630e45eb609c27b0e6d.jpg";